import { defineMessages } from 'react-intl';

export default defineMessages({
  filteredEmptySearchTitle: {
    id: 'app.products.emptyState.filtered.title',
    defaultMessage: 'We had a good look...',
  },
  filteredEmptySearchText: {
    id: 'app.products.emptyState.filtered.text',
    defaultMessage: "But we couldn't find that, sorry.",
  },
  mobileEmptySearchTitle: {
    id: 'app.products.emptyState.mobile.title',
    defaultMessage: 'Switch to desktop',
  },
  mobileEmptySearchText: {
    id: 'app.products.emptyState.mobile.text',
    defaultMessage: 'Switch to desktop to create your first {productName}',
  },
  noTemplatesTitle: {
    id: 'app.products.emptyState.noTemplates.title',
    defaultMessage: 'Looking for {productName} templates?',
  },
  noTemplatesContactAccountManagerText: {
    id: 'app.products.emptyState.noTemplates.accountManager',
    defaultMessage: 'To set one up, contact your MOO Account Manager.',
  },
  noTemplatesContactCustomerServiceText: {
    id: 'app.products.emptyState.noTemplates.customerService',
    defaultMessage: 'To set one up, contact our Customer Service.',
  },
  noTemplatesContactAdministratorText: {
    id: 'app.products.emptyState.noTemplates.administrator',
    defaultMessage: 'To set one up, contact your primary administrator.',
  },
  noTemplatesFullUploadText: {
    id: 'app.products.emptyState.noTemplates.fullUploadText',
    defaultMessage: 'Or, to upload your own design, click the ‘+’ button in the top right.',
  },
  noProductsCreateTitle: {
    id: 'app.products.emptyState.noProducts.create.title',
    defaultMessage: 'Let’s get started',
  },
  noProductsCreateText: {
    id: 'app.products.emptyState.noProducts.create.text',
    defaultMessage: 'To create your first {productName}, click the ‘+’ button in the top right.',
  },
  noProductsCreateTitleFullUpload: {
    id: 'app.products.emptyState.noProductsFullUpload.create.title',
    defaultMessage: 'Let’s get started',
  },
  noProductsCreateTextFullUpload: {
    id: 'app.products.emptyState.noProductsFullUpload.create.text',
    defaultMessage:
      'To create your first {productName} from a template or upload your own design, click the ‘+’ button in the top right.',
  },
  noProductsNoTemplateFullUploadText: {
    id: 'app.products.emptyState.noProductsNoTemplate.fullUploadText',
    defaultMessage: 'Select the ‘+’ button in the top right to upload a design.',
  },
  noProductsContactTitle: {
    id: 'app.products.emptyState.noProducts.contact.title',
    defaultMessage: 'No products shared with you yet',
  },
  noProductsContactText: {
    id: 'app.products.emptyState.noProducts.contact.text',
    defaultMessage: 'To set one up, drop an email to',
  },
  cannotOrderAccessoriesTitle: {
    id: 'app.products.emptyState.cannotOrderAccessories.title',
    defaultMessage: 'Looking for more MOO products?',
  },
  cannotOrderAccessoriesText: {
    id: 'app.products.emptyState.cannotOrderAccessories.text',
    defaultMessage: 'You need permission to view this page. Get in touch with your Primary Admin to get access:',
  },
});
